var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"merch",attrs:{"text":"","rounded":"","to":"/build"}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }